export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13254.7c3633e7.jpg";